import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';

import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
  
import { GlobalComponent } from 'src/app/global/global.component';
import { GetTaxListBO } from '../taxs-details.modal';

@Injectable({
  providedIn: 'root'
})

export class TaskPercentDateService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }

  public execute(TaxPercentstate: GetTaxListBO): void {
    this.getTaxPercentList(TaxPercentstate).subscribe(x => super.next(x));
  }

  getTaxPercentList(TaxPercentstate?: GetTaxListBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/TaxPercent/GetTaxPercentListFilter?", TaxPercentstate)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
}
